module.exports = __webpack_public_path__ + "img/hr-garballo-mini-dry-10.2343261c.png";